// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kU2on","left":"styles_left__35A4c"};